import {html, type HTMLTemplateResult} from "lit";
import {customElement} from "lit/decorators/custom-element.js";
import {AbstractTileComponent} from "./abstract-tile.component";
import type {GimmickLinkTarget} from "../../../domain/entities/link-targets/gimmick-link-target";
import {GIMMICK_RENDERERS} from "./gimmick-renderers";

/**
 * A tile carrying a gimmick (feature plan 0071): the tile's text as a caption (the same icon-and-text block
 * every tile renders), the gimmick below it. Not a link — the body has no click of its own; the gimmick's
 * buttons are its only controls.
 *
 * `dashboard-creator._mountTile` reaches this class only for a valid `GimmickLinkTarget`: an unknown or broken
 * gimmick is an `UnknownLinkTarget` and mounted as a plain tile.
 */
@customElement('link-tile-gimmick')
export class LinkTileGimmickComponent extends AbstractTileComponent<GimmickLinkTarget> {

    protected override _renderBody(): HTMLTemplateResult {
        return html`
            <div class="dashboard-tile__link dashboard-tile__gimmick">
                <div class="dashboard-tile__caption">${this._renderIconAndText()}</div>
                ${GIMMICK_RENDERERS[this.target.gimmick]({tileId: this.tileId, options: this.target.options})}
            </div>
        `;
    }

}
